import { Botao, Modal } from '../componentes/Flutuante';

/** Atualização pronta (E3): reiniciar agora ou depois (instala ao sair). */
export function AtualizacaoPronta({
  versao,
  notas,
  aoReiniciar,
  aoFechar,
}: {
  versao: string;
  notas: string[];
  aoReiniciar: () => void;
  aoFechar: () => void;
}) {
  return (
    <Modal
      titulo="Nova versão pronta"
      descricao={`A ${versao} foi baixada. Reinicie para aplicar — leva uns 5 segundos.`}
      aoFechar={aoFechar}
      largura={420}
      rodape={
        <>
          <Botao tipo="fantasma" onClick={aoFechar}>
            Depois
          </Botao>
          <Botao data-foco-inicial onClick={aoReiniciar}>
            Reiniciar agora
          </Botao>
        </>
      }
    >
      {notas.length ? (
        <div className="flex flex-col gap-2">
          <span className="text-xs font-semibold tracking-[.04em] text-texto-3 uppercase">
            Novidades
          </span>
          <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-sm text-texto-2">
            {notas.map((nota) => (
              <li key={nota}>{nota}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </Modal>
  );
}
